import React from 'react';
import {Typography} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import PropTypes from 'prop-types';

function Option(props) {
   const estiloUnaLinea = props.selectProps.unaLinea
      ? {textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'pre'}
      : undefined;
   const indicadorTitulos = props.selectProps.titulos;
   const {onMouseMove, onMouseOver, ...other} = props.innerProps;

   return (
      <ListItem
         ref={props.innerRef}
         selected={props.isFocused}
         component="div"
         style={{
            fontWeight: props.isSelected ? 500 : 400
         }}
         button
         {...other}
      >
         <Typography
            variant="body1"
            title={indicadorTitulos ? props.children : undefined}
            style={estiloUnaLinea}
         >
            {props.children}
         </Typography>
      </ListItem>
   );
}

Option.propTypes = {
   /**
    * The children to be rendered.
    */
   children: PropTypes.node,
   /**
    * props passed to the wrapping element for the group.
    */

   innerProps: PropTypes.shape({
      id: PropTypes.string.isRequired,
      key: PropTypes.string,
      onClick: PropTypes.func.isRequired,
      onMouseMove: PropTypes.func.isRequired,
      onMouseOver: PropTypes.func.isRequired,
      tabIndex: PropTypes.number.isRequired
   }),

   /**
    * Inner ref to DOM Node
    */

   innerRef: PropTypes.oneOfType([
      PropTypes.oneOf([null]),
      PropTypes.func,
      PropTypes.shape({
         current: PropTypes.any
      })
   ]),

   /**
    * Whether the option is focused.
    */
   isFocused: PropTypes.bool.isRequired,
   /**
    * Whether the option is selected.
    */

   isSelected: PropTypes.bool.isRequired
};
export default Option;
